var Backbone = require('backbone');


/* Really a 'key' tree and here is implementation specific -- I can't find a good library --
    and now using backbone models, TODO: stop THIS */

module.exports = Backbone.Model.extend({

  defaults: function() {

      return {

          rowLevel: null, // TODO: set the row level on add from the parent ...
          isRoot: false,

          parent: null, // try a ref to the parent ...
          parentId: null,
          parentIdAttribute: '',

          children: {} // could be an array ? -- maybe we always make an array instead ?

      };


    },

    isRoot: function() {
        return this.get('isRoot');
    },

    walkDown: function( cb ) {

        cb( this );

        _.each(  this.getChildren(), function(c) {

           c.walkDown( cb.bind(c) );

        }, this );

    },

    /** -- for FR tree, not using since can hits can have 2 parents */
    walkUp: function( cb ) {

        cb( this );

        if ( this.isRoot() ) {
            return;
        }

        var parent = this.getParent();
        parent.walkUp( cb.bind(parent) );

    },

    /* predicate fn argument is the node */
    filter: function( predicate ) {

        var nodes = [];

        this.walkDown( function(node) {

            if ( predicate(node) ) {
                nodes.push(node);
            }

        });

        return nodes;

    },


    removeAllChildren: function() {
        this.destroy();
    },

    getLowestLevelChildren: function( ) {

        var nodes = [];

        this.walkDown( function(node) {

            if ( !node.hasChildren() ) {
                nodes.push( node );
            }

        });

        return nodes;

    },


    getChildren: function() {
        return this.get('children');
    },


    getChild: function( childId ) {
        return this.getChildren()[childId];
    },

    hasChild: function( childId ) {
        return this.get('children')[childId];
    },

    hasChildren: function() {
        return Object.keys( this.getChildren() ).length > 0;

    },

    getFirstChild: function() {

        var children = this.getChildren();
        return children[ Object.keys(children )[0] ];

    },

    hasMultipleChildren: function() {
        return Object.keys( this.getChildren() ).length > 1;
    },

    addChild: function( childId, child ) {
        this.get('children')[childId] = child;
        return child;
    },

    /**
     *  oh fuck backbone ... can i just break the link? -- what out for listeners however -- would feel more confident with id's
     *  need to break the reference first?
     *  I think just removing the link will break the reference and allow for garbage collection
     * TODO: any cleanup -- I'm just breaking the link from the caller ... ?
     */
    removeChild: function( childId ) {

        return delete this.getChild(childId);

    },


    getParent: function() {
        return this.get('parent');
    },

    parentHasMultipleChildren: function() {
        return this.parent.hasMultipleChildren();
    },

    /* Experiemntal -- and not very generic *-- not using /
    sortChildren: function() {

        var sortedChildren = _.sortBy(  this.getChildren(), c => c.get('pageNumber') );

        this.removeAllChildren();

        this.set( 'children', sortedChildren );


    },



    /**
     * TODO: don't make it a BB model anymore
     * Now just break the references to children
     */
    destroy: function() {

        /*

        I don't think this necessary -- just break the link to the children
        this.walkDown( function(node) {

            node.stopListening();
            node.off();

            var children = node.getChildren();

            for ( var s in children ) {

                children[s].destroy();
                delete children[s]; // mostly just breaking the ref
            }



        });

        */

        var children = this.getChildren();
        for ( var s in children ) {
            delete children[s];
        }


    }




});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hierarchy/node.js
 ** module id = 662
 ** module chunks = 0
 **/